/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_massmol_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Molarity is the amount of solute in moles per litre of solution, written M (mol/L). A 1 M solution contains one mole of solute in every litre.`)
};

const es_massmol_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La molaridad es la cantidad de soluto en moles por litro de solución, escrita M (mol/L). Una solución 1 M contiene un mol de soluto en cada litro.`)
};

const de_massmol_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Molarität ist die Stoffmenge des gelösten Stoffes in Mol pro Liter Lösung, geschrieben M (mol/L). Eine 1-M-Lösung enthält ein Mol gelösten Stoff pro Liter.`)
};

const nl_massmol_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Molariteit is de hoeveelheid opgeloste stof in mol per liter oplossing, geschreven als M (mol/L). Een 1 M oplossing bevat één mol opgeloste stof per liter.`)
};

const fr_massmol_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La molarité est la quantité de soluté en moles par litre de solution, notée M (mol/L). Une solution à 1 M contient une mole de soluté par litre.`)
};

const it_massmol_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La molarità è la quantità di soluto in moli per litro di soluzione, indicata con M (mol/L). Una soluzione 1 M contiene una mole di soluto in ogni litro.`)
};

const pt_br2_massmol_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Molaridade é a quantidade de soluto em mols por litro de solução, escrita como M (mol/L). Uma solução 1 M contém um mol de soluto em cada litro.`)
};

const pt_massmol_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A molaridade é a quantidade de soluto em moles por litro de solução, escrita M (mol/L). Uma solução 1 M contém um mole de soluto em cada litro.`)
};

const ja_massmol_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`モル濃度は溶液1リットルあたりの溶質のモル数で、M (mol/L) と表記します。1 Mの溶液は1リットルあたり1モルの溶質を含みます。`)
};

const zh_massmol_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`摩尔浓度是每升溶液中溶质的摩尔量，记作 M（mol/L）。1 M 溶液每升含有一摩尔溶质。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const massmol_faq_a1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.massmol_faq_a1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("massmol_faq_a1", locale)
	if (locale === "en") return en_massmol_faq_a1(inputs)
	if (locale === "es") return es_massmol_faq_a1(inputs)
	if (locale === "de") return de_massmol_faq_a1(inputs)
	if (locale === "nl") return nl_massmol_faq_a1(inputs)
	if (locale === "fr") return fr_massmol_faq_a1(inputs)
	if (locale === "it") return it_massmol_faq_a1(inputs)
	if (locale === "pt-BR") return pt_br2_massmol_faq_a1(inputs)
	if (locale === "pt") return pt_massmol_faq_a1(inputs)
	if (locale === "ja") return ja_massmol_faq_a1(inputs)
	return zh_massmol_faq_a1(inputs)
};